import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f44049"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under-controls" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "under-controls-item under-controls-help hide-pc" }, [
    /*#__PURE__*/_createElementVNode("dl", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("dt", null, [
          /*#__PURE__*/_createTextVNode("ヘルプ"),
          /*#__PURE__*/_createElementVNode("span", { class: "icon-help" })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_2 = { class: "copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.globalStore.copyright || '©︎2021 ANEOS Corporation. All Rights Reserved.'), 1)
  ]))
}